type AccessMember = { staffId: number; userId?: number | null; isActive: boolean; name?: string | null; userName?: string | null };
type PromptFn = (message: string) => string | null;
type ConfirmFn = (message: string) => boolean;

function memberName(member: AccessMember) {
  return member.userName ?? member.name ?? "este usuário";
}

export function requestStaffAccessStatusChange(member: AccessMember, promptFn: PromptFn, confirmFn: ConfirmFn) {
  const action = member.isActive ? "suspender" : "reativar";
  const reason = promptFn(`Informe o motivo para ${action} o acesso de ${memberName(member)}:`)?.trim();
  if (!reason || !confirmFn(`Confirmar ${action} o acesso de ${memberName(member)}?`)) return null;
  return { staffId: member.staffId, isActive: !member.isActive, reason };
}

export function requestUserSessionLogout(member: AccessMember, promptFn: PromptFn, confirmFn: ConfirmFn) {
  if (!member.userId) return null;
  const reason = promptFn(`Informe o motivo para encerrar a sessão de ${memberName(member)}:`)?.trim();
  if (!reason || !confirmFn(`Confirmar encerramento da sessão de ${memberName(member)}?`)) return null;
  return { userId: member.userId, reason };
}
